import React from 'react';
import '../fulfillmentTiles.scss';

export const BackorderedAlert = () => {
  return (
    <div className="alert-inline alert-inline--warning inventory--warning-tiles">
      <div>
        <span>This product is currently</span>
        <span className="u__bold">&nbsp;backordered.&nbsp;</span>
        <span>{'We won\'t charge you until it ships.'}</span>
      </div>
    </div>
  );
};